import React from "react";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import Dashboard from "./Page/Home";

import CreateQuestionBank from "./Page/CreateQuestionBank";
import LisytQuestionBank from "./Page/ListQuestionBank";
import ExamAttempts from "./Page/ExamAttempts";

import ExamDetail from "./Page/ExamDetail";
import ExamPreview from "./Page/ExamPreview";
import QuestionPage from "./Page/QuestionPage";
import QuizResultPage from "./Page/QuizResultPage";
import Login from "./Page/Login";
import Signup from "./Page/Signup";

import ProfilePage from "./Page/ProfilePage";
import ExamsAttendedByStudent from "./Page/ExamsAttendedByStudent";

// ✅ Private Route wrapper
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("accessToken");
  return token ? children : <Navigate to="/login" replace />;
};

// ✅ Public Route wrapper to prevent logged-in users seeing login/signup
const PublicRoute = ({ children }) => {
  const token = localStorage.getItem("accessToken");
  return token ? <Navigate to="/dashboard" replace /> : children; // ← Changed from "/" to "/dashboard"
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/signup"
          element={
            <PublicRoute>
              <Signup />
            </PublicRoute>
          }
        />
        {/* Private routes */}
        <Route
          path="/"
          element={<Navigate to="/dashboard" replace />} 
        />
        <Route
          path="/dashboard" 
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/CreateQuestionBank"
          element={
            <PrivateRoute>
              <CreateQuestionBank />
            </PrivateRoute>
          }
        />
        <Route
          path="/ListQuestionBank"
          element={
            <PrivateRoute>
              <LisytQuestionBank />
            </PrivateRoute>
          }
        />
        <Route
          path="/exam/:id/attempts"
          element={
            <PrivateRoute>
              <ExamAttempts />
            </PrivateRoute>
          }
        />
        <Route
          path="/exam/:id"
          element={
            <PrivateRoute>
              <ExamDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/exam/preview/:id"
          element={
            <PrivateRoute>
              <ExamPreview />
            </PrivateRoute>
          }
        />
        <Route
          path="/exam/:id/questions"
          element={
            <PrivateRoute>
              <QuestionPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/quiz-result/:id"
          element={
            <PrivateRoute>
              <QuizResultPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/questionbank/edit/:id"
          element={
            <PrivateRoute>
              <CreateQuestionBank />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/ExamsAttendedByStudent"
          element={
            <PrivateRoute>
              <ExamsAttendedByStudent />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />{" "}
      </Routes>
    </BrowserRouter>
  );
}
